function getSingleParam<TParam = unknown>(params: [TParam] | Record<string, TParam>, paramName: string) {
  return Array.isArray(params) ? params[0] : params[paramName];
}

function isNullOrUndefined(value: unknown): value is undefined | null {
  return value === null || value === undefined;
}

function isEmptyArray(arr: unknown): boolean {
  return Array.isArray(arr) && arr.length === 0;
}

function isEmpty(value: unknown): boolean {
  if (value === null || value === undefined || value === "") {
    return true;
  }

  if (Array.isArray(value) && value.length === 0) {
    return true;
  }

  return false;
}

function requiredValidator(value: unknown) {
  if (isNullOrUndefined(value) || isEmptyArray(value) || value === false) {
    return false;
  }

  return !!String(value).trim().length;
}

function emailValidator(value: unknown) {
  if (isEmpty(value)) {
    return true;
  }

  const re =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (Array.isArray(value)) {
    return value.every((val) => re.test(String(val)));
  }

  return re.test(String(value));
}

function urlValidator(value: unknown) {
  if (isEmpty(value)) {
    return true;
  }

  const re = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

  if (Array.isArray(value)) {
    return value.every((val) => re.test(String(val)));
  }

  return re.test(String(value));
}

function hexColorValidator(value: unknown) {
  if (isEmpty(value)) {
    return true;
  }

  const re = /^#[a-fA-F0-9]{6}$/;

  return re.test(String(value));
}

function minValidator(value: unknown, params: [string | number] | { length: string | number }): boolean {
  if (isEmpty(value)) {
    return true;
  }

  const length = getSingleParam(params, "length");
  if (Array.isArray(value)) {
    return value.every((val) => minValidator(val, { length }));
  }

  return [...String(value)].length >= Number(length);
}

function maxValidator(value: unknown, params: [string | number] | { length: string | number }): boolean {
  if (isEmpty(value)) {
    return true;
  }

  const length = getSingleParam(params, "length");
  if (Array.isArray(value)) {
    return value.every((val) => maxValidator(val, { length }));
  }

  return [...String(value)].length <= Number(length);
}

const validate = {
  email: emailValidator,
  required: requiredValidator,
  min: minValidator,
  max: maxValidator,
  hex: hexColorValidator,
  url: urlValidator,
};

export default validate;
